// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CompanyCustomerService = {};

CompanyCustomerService.getCompanyCustomerList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/customercompany/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

CompanyCustomerService.postCompanyCustomer = function (data) {
  return lossClient({
    url: "/CustomerCompany/add",
    method: "post",
    data: data,
  });
};

CompanyCustomerService.updateCompanyCustomer = function (data) {
  const { id, CIFNo, ...requestBody } = data;
  return lossClient({
    url: "/CustomerCompany/Edit",
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.deleteCompanyCustomer = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/CustomerCompany/delete",
    method: "delete",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.getCompanyCustomerLegalDocList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/CompanyCustomerLegalDoc/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

CompanyCustomerService.postCompanyCustomerLegalDoc = function (data) {
  return lossClient({
    url: "/CompanyCustomerLegalDoc/add",
    method: "post",
    data: data,
  });
};

CompanyCustomerService.postCompanyCustomerLegalDocCsv = function (data) {
  return lossClient({
    url: "/CompanyCustomerLegalDoc/upload",
    method: "post",
    data: data,
  });
};

CompanyCustomerService.updateCompanyCustomerLegalDoc = function (data) {
  const { Id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerLegalDoc/edit",
    method: "put",
    headers: {
      "x-requestId": data.Id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.deleteCompanyCustomerLegalDoc = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerLegalDoc/delete",
    method: "delete",
    headers: {
      "x-requestId": data,
    },
    data: requestBody,
  });
};

CompanyCustomerService.getCompanyCustomerShareHolderList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/CompanyCustomerShareHolder/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

CompanyCustomerService.postCompanyCustomerShareHolder = function (data) {
  return lossClient({
    url: "/CompanyCustomerShareHolder/add",
    method: "post",
    data: data,
  });
};

CompanyCustomerService.updateCompanyCustomerShareHolder = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerShareHolder/Edit",
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.deleteCompanyCustomerShareHolder = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerShareHolder/delete",
    method: "delete",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.getCompanyCustomerManagementList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/CompanyCustomerManagement/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

CompanyCustomerService.postCompanyCustomerManagement = function (data) {
  return lossClient({
    url: "/CompanyCustomerManagement/add",
    method: "post",
    data: data,
  });
};

CompanyCustomerService.updateCompanyCustomerManagement = function (data) {
  const { Id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerManagement/edit",
    method: "put",
    headers: {
      "x-requestId": data.Id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.deleteCompanyCustomerManagement = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerManagement/delete",
    method: "delete",
    headers: {
      "x-requestId": data,
    },
    data: requestBody,
  });
};

CompanyCustomerService.getCompanyCustomerFinanceList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url:
      "/CompanyCustomerFin/itemlist?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    method: "get",
  });
};

CompanyCustomerService.postCompanyCustomerFinance = function (data) {
  return lossClient({
    url: "/CompanyCustomerFin/add",
    method: "post",
    data: data,
  });
};

CompanyCustomerService.updateCompanyCustomerFinance = function (data) {
  const { id, CIFNo, ...requestBody } = data;

  return lossClient({
    url: "/CompanyCustomerFin/edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

CompanyCustomerService.deleteCompanyCustomerFinance = function (data) {
  const { id, ...requestBody } = data;
  return lossClient({
    url: "/CompanyCustomerFin/delete",
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

export default CompanyCustomerService;
